import gql from "graphql-tag";

// The project row's own scalars, bundled with the trail row describing the change, in ONE document.
// Hasura runs a document's root fields serially inside one transaction, so the change and its
// version can never exist without each other — the same shape as
// UpsertProjectCalculationWithVersionMutation.
//
// `_set` rather than an upsert: the row always exists by the time anything edits it (POST
// /api/BuildingProject/base created it), so there is no insert path to arbitrate. The column list is
// the settings page's Project section plus the two years, and nothing else: `active_revision_id`,
// `tenant_id`, the timestamps, the soft-delete pair and the `source_*` lineage are all off limits to
// a client, and `speckle_stream_id` belongs to the Speckle connect flow rather than this form.
const UPDATE_PROJECT_WITH_VERSION_MUTATION = `
  mutation UpdateProjectWithVersion($projectId: uuid!, $project: project_set_input!, $version: projectVersion_insert_input!) {
    project: update_project_by_pk(pk_columns: { id: $projectId }, _set: $project) {
      id
      name
      projectNumber
      clientName
      builderName
      lcaResponsibleName
      numberOfPeople
      buildingTypeId
      projectStatusId
      yearOfConstruction
      yearOfCommissioning
    }

    version: insert_projectVersion_one(object: $version) {
      id
    }
  }
`;

/**
 * Built from a plain string via `gql(...)` — deliberately NOT a `gql\`\`` tagged template — so
 * graphql-codegen's document scan skips it.
 *
 * `update_project_by_pk` does not exist yet: the `project` table has select permissions only, for
 * every role, so Hasura generates no update field for it. A tagged template here would therefore
 * fail `npm run codegen`, and with it the `prebuild` and the whole build, exactly as
 * GetAgentUsageRequestsQuery would before its view shipped.
 *
 * Once `project` has a user-role update permission: convert both documents in this file to tagged
 * templates, run `npm run codegen`, and swap `projectScalarWrites.ts` onto the generated types.
 */
export const UpdateProjectWithVersionMutation = gql(UPDATE_PROJECT_WITH_VERSION_MUTATION);

// The same write without the trail row, for an environment that has the project update permission
// but not the versioning tables. `projectScalarWrites` falls back to this on the rollout signature.
const UPDATE_PROJECT_MUTATION = `
  mutation UpdateProject($projectId: uuid!, $project: project_set_input!) {
    project: update_project_by_pk(pk_columns: { id: $projectId }, _set: $project) {
      id
      name
      projectStatusId
    }
  }
`;

export const UpdateProjectMutation = gql(UPDATE_PROJECT_MUTATION);

export default UpdateProjectWithVersionMutation;
